import { Skill } from "./classroom-games.model";

export interface IActivity {
	id: string;
	game: string;
	level: string;
	skin: string;
	text: string;
	column: string;
	description: string;
	skill: Skill;
	context: string;
	cognition: string;
	quadrant: string;
	requirements: {
		build: number;
		microphone?: boolean;
		playVideos?: boolean;
	};
	lesson: string;
	lessonId: string;
	gameType: string;
	layout: string;
	valid: boolean;
	version: number;
}

export interface ILessonActivities {
	lessonId: string;
	name: string;
	version: number;
	age: string;
	cefr: string;
	activities: ILessonActivity[];
}

export interface ILessonActivity {
	id: string;
	skill: string;
	ages: string[];
	game: string;
	level: string;
	text: string;
	image: string;
	build: number;
	isVideo: boolean;
	context: string;
	cognition: string;
	column: string;
	description: string;
	valid: boolean;
  }